import defaultSettings from '@/settings';
import { pro, setting } from '@/utils/settings';
import { getCurrentProInfo } from '@/utils';
var defaultTitle = defaultSettings.title || 'Vue Admin Template';
var projectDesc = getCurrentProInfo(pro, setting).projectDesc || '';
var settingTitle = "".concat(projectDesc);
var title = settingTitle || defaultTitle;
export default function getPageTitle(pageTitle) {
  return "".concat(title);
}